import React, { FC } from 'react';
import DefaultRolesListPage from './default-role-list';
import { Route, Routes } from 'react-router-dom';
import RoleInformationPage from 'src/common/components/business/role-information-page';
import { Selector } from 'src/common/types';
import { useTranslation } from 'react-i18next';

const RolesIndex: FC = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route path={`/*`} element={<DefaultRolesListPage />} />
      <Route
        path={`/update/:id`}
        element={
          <RoleInformationPage
            canBeAssignedByDefaultToScopeCreator
            canBePartnersOnly
            isDefaultRole
            header={t('EditDefaultRole')}
            maxSelector={Selector.Partners}
            mode="edit"
            previousRoute="/default-roles"
            routes={[
              { path: '', breadcrumbName: t('Home') },
              { path: 'default-roles', breadcrumbName: t('DefaultRoles') },
              { path: `update`, breadcrumbName: t('EditDefaultRole') },
            ]}
          />
        }
      />
    </Routes>
  );
};

export default RolesIndex;
